// src/pages/Project1.js
import React from 'react';

const Project1 = () => {
  return <div><h1>Vitalise.ai Mobile App</h1></div>;
};

export default Project1;